module.exports = __webpack_public_path__ + "09c3b5a4acf6c0c8acdb419be166b4c8.woff";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensanssemibolditalic.woff
// module id = 695
// module chunks = 57